"use client";

import Link from "next/link";

// import Link from "next/link";
// import { usePathname } from "next/navigation";

export function useCustomLink(href: any) 
{
    // const pathname = usePathname();
    // const isMobile = pathname.startsWith("/mobile");

    // if (typeof href === "string") 
    // {
    //     if (href === "#") 
    //     {
    //         return href;
    //     }

    //     return isMobile ? `/mobile${href}` : href;
    // }

    // if (typeof href === "object" && href.pathname) 
    // {
    //     return {
    //         ...href,
    //         pathname : isMobile ? `/mobile${href.pathname}` : href.pathname,
    //     };
    // }

    return href;
}

// const handleClick = () => 
// {
//     window.scrollTo(0, 0);
// };

export default function CustomLink({ href,  children, ...props }: any) 
{
    //const url = useCustomLink(href);

    // DESLIGAR O PREFETCH POIS ELE NÃO FICA EM CACHE ISSO FAZ COM ELE CONSUMA SERVIDOR
    return (
        <Link href={href || ""} {...props} prefetch={false} scroll={true} >
            {children}
        </Link>
    );
}
